import { useTranslation } from 'react-i18next';
import { CellContext } from '@tanstack/react-table';
import { Device } from '@/types/device.types';
import { formatDateAsYearMonthDayHourMinute } from '@/utils/formatters/dateFormatter';

/** Fecha última operación con TZ persistida (evita depender de column.id en TanStack). */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DeviceLastOperationDateCell = (info: CellContext<Device, any>) => {
  const { t } = useTranslation();
  const date = info.getValue() as string | null | undefined;
  const tz = info.row.original.lastOperationTz ?? 'UTC';
  return <span>{date ? formatDateAsYearMonthDayHourMinute(date, tz) : t('common.never')}</span>;
};
